import React, { JSX, useEffect } from 'react';
import {
    Drawer,
    CircularProgress,
    Button
} from '@mui/material';
import { loadStripe } from '@stripe/stripe-js';
import {
    EmbeddedCheckoutProvider,
    EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { useAdminCheckoutCustomerSession } from "../hooks/subscription-manager-checkout-drawer.hooks";
import { CustomerAccount } from "../../../../../../types/entities";
import {
    useRefresh,
    useRecordContext
} from "react-admin";
import { adminURL } from "../../../../../utils/url-manager";
import {
    Close
} from '@mui/icons-material';

const stripePromise: Promise<any> = loadStripe(import.meta.env.VITE_STRIPE_PK);

export const SingleChargeCheckoutDrawer: (props: any) => JSX.Element = (props: any): JSX.Element => {
    const refresh: any = useRefresh();
    const customerAccount: CustomerAccount = useRecordContext();
    const datum = props.payload;
    const { loadingCheckout, checkoutSession, fetchCheckoutSession, error, expireCheckoutSession } = useAdminCheckoutCustomerSession();

    function handleButtonClick(): void {
        props.handleCheckoutPanelToggle(true)
        fetchCheckoutSession({
            name: datum?.name,
            quantity: datum?.quantity,
            price: datum?.price,
            currency: datum?.currency,
            accountId: customerAccount?.id,
            customer: customerAccount.accountHolder,
            checkoutType: 'single-checkout',
        });
    }

    function handleCheckoutPanelCancel(): void {
        // expireCheckoutSession();
        props.handleCheckoutPanelToggle(false)
    }

    // useEffect( (): () => void => {
    //     const handleBeforeUnload: (e: any) => void = (e: any): void => {
    //         expireCheckoutSession();
    //     };
    //     window.addEventListener('beforeunload', handleBeforeUnload);
    //     return (): void => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, [expireCheckoutSession] );

    return (
        <>
            <Button type="button"
                    disabled={ datum?.length <= 0 }
                    onClick={ handleButtonClick  }
                    variant="contained">
                <span>{ "Take Card Payment" }</span>
            </Button>
            { /* onClose empty here to control checkout session expiration on close */ }
            <Drawer open={ props.toggleCheckoutPanel } onClose={ (): void => {} }>
                <div className="stripe__hq-checkout">
                    { (loadingCheckout) &&
                        <div className="hq-checkout__checkout">
                            <div className="checkout__header">
                                <img src="/images/icon/nn-logo.png" alt="NN Logo" />
                                <span>{ "NokNok Admin Checkout" }</span>
                                <Button type="button"
                                        onClick={ handleCheckoutPanelCancel  }
                                        variant="contained">
                                    <Close />
                                </Button>
                            </div>
                            <div className="hq-checkout__loader">
                                <span>{ "Loading checkout..." }</span>
                                <CircularProgress sx={ { width: '50px', height: '50px' } } />
                            </div>
                        </div>

                    }
                    { (!loadingCheckout) &&
                        <>
                        { (error === '') &&
                            <div className="hq-checkout__checkout">
                                <div className="checkout__header">
                                    <img src="/images/icon/nn-logo.png" alt="NN Logo" />
                                    <span>{ "NokNok Admin Checkout" }</span>
                                    <Button type="button"
                                            onClick={ handleCheckoutPanelCancel  }
                                            variant="contained">
                                        <Close />
                                    </Button>
                                </div>
                                <div className="checkout__checkout">
                                    <EmbeddedCheckoutProvider
                                        stripe={ stripePromise }
                                        options={ {
                                            clientSecret: checkoutSession.clientSecret,
                                            onComplete: (): void => {
                                                console.log('checkout complete')
                                                // props.handleCreatePanelToggle();
                                                refresh();
                                                props.resetForm()
                                                // setTimeout( (): void => {
                                                //
                                                // }, 5000 );
                                            }
                                        } } >
                                        <EmbeddedCheckout />
                                    </EmbeddedCheckoutProvider>
                                </div>
                            </div>
                        }
                        { (error !== '') &&
                            <div className="hq-checkout__error">
                                <span>{ error }</span>
                            </div>
                        }
                        </>
                    }
                </div>
            </Drawer>
        </>
    );
}